import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  SafeAreaView,
  ScrollView,
} from "react-native";
import {LogoLight} from './../../images/Image';
import { Image } from "react-native";

export default function DeleteAccountScreen() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!email) return;
    setSubmitted(true);

  };

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.box}>
          <Image style={styles.logo} source={LogoLight} />

          <Text style={styles.title}>Delete Your Account</Text>

          <Text style={styles.subTitle}>
            We are sorry to see you go. Before deleting your account, please read
            the important information below.
          </Text>

          {/* INFO SECTION */}
          <View style={styles.infoBox}>
            <Text style={styles.infoTitle}>What happens when you delete?</Text>
            <Text style={styles.infoText}>
              • Your account will be permanently removed.
            </Text>
            <Text style={styles.infoText}>
              • All your personal data, activity history, and preferences will be deleted.
            </Text>
            <Text style={styles.infoText}>
              • This action cannot be undone.
            </Text>

            <Text style={[styles.infoTitle, { marginTop: 18 }]}>
              What data do we keep temporarily?
            </Text>
            <Text style={styles.infoText}>
              Certain records such as transaction logs and fraud-prevention logs may be
              stored for 30–90 days, as legally required.
            </Text>

            <Text style={[styles.infoTitle, { marginTop: 18 }]}>
              Processing Time
            </Text>
            <Text style={styles.infoText}>
              Your request will be processed within 7–30 days.
            </Text>
          </View>

          {!submitted ? (
            <>
              <Text style={styles.inputLabel}>Enter your email address</Text>

              <TextInput
                style={styles.input}
                placeholder="your@email.com"
                value={email}
                onChangeText={setEmail}
                autoCapitalize="none"
                keyboardType="email-address"
              />

              <TouchableOpacity
                onPress={handleSubmit}
                style={[styles.submitButton, !email && { opacity: 0.4 }]}
                disabled={!email}
              >
                <Text style={styles.submitText}>Submit Deletion Request</Text>
              </TouchableOpacity>
            </>
          ) : (
            <View style={styles.successBox}>
              <Text style={styles.successTitle}>Request Submitted</Text>
              <Text style={styles.successText}>
                Your account deletion request has been received. Our team will process
                your request shortly.
              </Text>
            </View>
          )}

          <Text style={styles.footerText}>
            For any issues, please contact us at{" "}
            <Text style={styles.link}>housecall.telemedicine@gmail.com</Text>
          </Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    width: "100%",
    maxWidth: 600,
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 3,
  },
  title: {
    fontSize: 28,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 8,
  },
  logo: {
    width: 220,
    height: 60,
    alignSelf: "center",
    marginBottom: 30
  },
  subTitle: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: "center",
    color: "#444",
  },
  infoBox: {
    backgroundColor: "#f5f8ff",
    padding: 16,
    borderRadius: 10,
    marginBottom: 24,
  },
  infoTitle: {
    fontSize: 18,
    fontWeight: "700",
    color: "#223",
  },
  infoText: {
    fontSize: 14,
    color: "#444",
    marginTop: 6,
  },
  inputLabel: {
    fontSize: 16,
    fontWeight: "600",
    marginBottom: 8,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    padding: 14,
    borderRadius: 10,
    fontSize: 16,
    backgroundColor: "#fff",
  },
  submitButton: {
    backgroundColor: "#d93025",
    padding: 15,
    borderRadius: 10,
    marginTop: 20,
  },
  submitText: {
    color: "#fff",
    textAlign: "center",
    fontSize: 16,
    fontWeight: "600",
  },
  successBox: {
    backgroundColor: "#e8ffe8",
    padding: 20,
    borderRadius: 12,
    marginTop: 10,
  },
  successTitle: {
    fontSize: 20,
    fontWeight: "700",
    color: "#2b8a3e",
  },
  successText: {
    marginTop: 8,
    fontSize: 15,
    color: "#333",
  },
  footerText: {
    marginTop: 30,
    textAlign: "center",
    fontSize: 14,
    color: "#444",
  },
  link: {
    color: "#0066ff",
    fontWeight: "700",
  },
});
